import { getGlobalNotify } from "@/components/Common/NotificationProvider";
import { getTokenLocalStorage, removeLocalStorage } from "@/utils/authHelper";
import axios from "axios";

const service = axios.create({
  baseURL: process.env.BaseURL,
  withCredentials: true,
  timeout: 0, // No timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // public apis ==> apis end points which need to make public without jwt tokens
    const publicPages: any = [
      "/core/contact",
      "/core/country-codes",
    ];
    const authRequired = !publicPages.includes(config.url);

    if (!navigator.onLine) {
      const notify = getGlobalNotify();
      notify({
        type: "warning",
        title: "You are offline",
        description: "Please check your internet connection.",
      });
      return Promise.reject(new axios.Cancel("You are offline"));
    }

    if (authRequired) {
      const currentUser = getTokenLocalStorage();
      if (currentUser && currentUser.accessToken) {
        config.headers["Authorization"] = "Bearer " + currentUser.accessToken;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  function (response) {
    const notify = getGlobalNotify();

    if (
      response.data &&
      typeof response.data.message === "string" &&
      response.data.isDisplayMessage
    ) {
      notify({
        type: "success",
        title: response.data.message,
      });
    }
    return response;
  },
  function (error) {
    const notify = getGlobalNotify();

    if (!error.response) {
      notify({
        type: "error",
        title: "Network error",
        description: "Server is unreachable or offline.",
      });
      return Promise.reject(error);
    }

    const { status, message, error: errorDetail } = error.response.data || {};
    const shouldHandle = !error.config.ignoreErrorHandler;

    if (shouldHandle && status >= 400 && status <= 599) {
      const errors: string[] = [];
      if (Array.isArray(errorDetail?.body)) {
        errorDetail.body.forEach((msg: string, index: number) => {
          errors.push(`${index + 1}: <strong>${msg}</strong>`);
        });
      }

      if (status === 403) {
        notify({
          type: "warning",
          title: "Authentication required.",
        });
        removeLocalStorage();
      } else {
        const notifyPayload: any = {
          type: "error",
          title: message || "An error occurred",
        };
        if (errors.length > 0) {
          notifyPayload.description = errors.join("<br/>");
        }
        notify(notifyPayload);
      }
    }

    return Promise.reject(error);
  }
);

export default service;
